import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonGroup, FormControl, OverlayTrigger, Tooltip, } from 'react-bootstrap';
import _ from 'underscore';
import accounting from 'accounting';
import { titleize } from 'underscore.string';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';
import CargomaticModal from 'components/v2/modal';
import DoRequestChanges from 'components/modules/shipments/delivery-order/RequestChanges';
import { getLatestStatus } from 'utils/formatters/shipments';
import ConfirmModal from 'components/ui/modals/ConfirmModal';
import SessionStore from 'stores/SessionStore';
import { withTranslation, Translation } from 'react-i18next';
import { isIntermodalShipmentType } from 'helpers/shipment-types';
import { sluggify } from 'utils/localization/utils';
import ShipmentStore from 'stores/ShipmentStore';
import { DistanceUnitFormatter, LoadDimensionFormatter, LoadUnitFormatter, } from 'components/modules/master/formatters';
import { withLocaleContext } from 'providers/locale-settings-context';
import { getYards } from 'utils/YardAPIUtils';
import { getDocumentsV2, getSignedUrl } from 'utils/DocumentsAPIUtils';
import { getErrorFromResponse } from 'utils/graphQL/utils';
import OfferAccessorial from 'components/offers/offer-accessorial';
import { isHazMat } from 'helpers/stops';
import { canEditAppointmentWindow, calculatePalletSpaces, } from 'helpers/shipments';
import { getFileIconClass, isProd } from 'helpers/helper_functions';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
import AddAppointmentModal from 'components/ui/tailwind/modals/AddAppointmentModal';
import { showToast } from 'stores/ToastStore';
import { Disclosure } from '@headlessui/react';
import { ChevronRightIcon, ChevronUpIcon, PencilIcon, } from '@heroicons/react/20/solid';
import Alert from 'components/ui/Alert';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import NextSteps from 'components/modules/shipments/next-steps/NextSteps';
import Stop from './Stop';
import ShipmentDetailDateItem from '../details/ShipmentDetailDateItem';
import EditReferenceNumbersModal from '../EditReferenceNumbersModal';
const TOOLTIPS = {
    hazMat: (React.createElement(Tooltip, { id: "hazMat" },
        React.createElement(Translation, null, (t, { i18n }) => React.createElement("p", null, t('SHIPMENT_HAZARDOUS_MATERIALS'))))),
    editReferences: (React.createElement(Tooltip, { id: "tooltip-edit-references" },
        React.createElement(Translation, null, (t, { i18n }) => React.createElement("p", null, t('CLICK_TO_EDIT_REF_NUMS'))))),
    references: (React.createElement(Tooltip, { id: "tooltip-route-details" },
        React.createElement(Translation, null, (t, { i18n }) => React.createElement("p", null, t('REF_NUMS_NOTE'))))),
};
function getTrackingId(props) {
    const job = props.job || {};
    const referenceNumbers = job.reference_numbers || [];
    return (referenceNumbers.find((n) => n.name === 'tracking_id') || {}).value;
}
class JobDetailCard extends Component {
    constructor(props) {
        super(props);
        this.findErrorsAndShowToast = (response, operationName) => {
            const errorMessages = getErrorFromResponse(response);
            if (errorMessages) {
                showToast(`${operationName} Error`, `${operationName} failed with error: ${errorMessages}`, 'error');
            }
            return errorMessages;
        };
        this.onRequestModalHide = () => this.setState({ showRequestChangesModal: false });
        this.onRequestModalShow = () => this.setState({ showRequestChangesModal: true });
        this.onAcceptDeliveryOrder = () => {
            const body = { status: 'accepted' };
            if (!body) {
                return null;
            }
            ShipmentsActionCreators.updateDeliveryOrderStatus(this.props.job._id, body);
        };
        this.onDeclineDeliveryOrder = () => {
            const body = { status: 'declined' };
            if (!body) {
                return null;
            }
            ShipmentsActionCreators.updateDeliveryOrderStatus(this.props.job._id, body);
            this.setState({ showConfirmDeclineModal: false });
        };
        this.handleDeliveryOrderStatusUpdate = () => {
            const result = ShipmentStore.getDeliveryOrderUpdateStatus();
            if (result.action === 'declined' && result.status) {
                window.location.href = '/shipments';
            }
        };
        this.handleSaveShipmentDate = (field) => (value) => {
            const { job: shipment } = this.props;
            switch (field) {
                case 'estimated_arrival':
                    ShipmentsActionCreators.updateEstimatedArrival(shipment, value);
                    break;
                case 'arrival_date':
                    ShipmentsActionCreators.updateArrivalDate(shipment, value);
                    break;
                case 'discharge_date':
                    ShipmentsActionCreators.updateDischargeDate(shipment, value);
                    break;
                case 'last_free_date':
                    ShipmentsActionCreators.updateLastFreeDate(shipment, value);
                    break;
                default:
            }
        };
        this.handleWindowSave = (updates) => {
            const { job } = this.props;
            const { appointmentStop: stop } = this.state;
            const updatedStop = Object.assign(Object.assign({}, stop), updates);
            ShipmentsActionCreators.updateShipmentStopWindow(job, updatedStop, updates);
            this.setState({
                showAddAppointmentModal: false,
                appointmentStop: null,
            });
        };
        this.handleEditAppointmentWindow = (stop) => {
            this.setState({
                showAddAppointmentModal: true,
                appointmentStop: stop,
            });
        };
        this.handleCancelWindowEdit = () => {
            this.setState({
                showAddAppointmentModal: false,
                appointmentStop: null,
            });
        };
        this.handleEditTrackingIdStart = () => this.setState({ editingTrackingId: true });
        this.handleEditTrackingIdChange = (e) => this.setState({ tracking_id: e.target.value });
        this.handleEditTrackingIdCancel = () => this.setState({
            tracking_id: getTrackingId(this.props),
            editingTrackingId: false,
        });
        this.handleEditTrackingIdSave = () => {
            const { job: { reference_numbers: currentReferenceNumbers }, } = this.props;
            let trackingIdRefNum;
            const index = currentReferenceNumbers.findIndex((r) => r.name === 'tracking_id');
            let reference_numbers;
            if (index !== -1) {
                trackingIdRefNum = currentReferenceNumbers[index];
                trackingIdRefNum.value = this.state.tracking_id;
                reference_numbers = [
                    ...currentReferenceNumbers.slice(0, index),
                    trackingIdRefNum,
                    ...currentReferenceNumbers.slice(index + 1),
                ];
            }
            else {
                trackingIdRefNum = {
                    name: 'tracking_id',
                    value: this.state.tracking_id,
                };
                reference_numbers = [...currentReferenceNumbers, trackingIdRefNum];
            }
            ShipmentsActionCreators.updateReferenceNumbers(this.props.job, reference_numbers);
            setTimeout(() => this.setState({ editingTrackingId: false }), 250);
        };
        this.handleEditReferenceNumbers = () => this.setState({ showEditReferenceNumbersModal: true });
        this.handleCloseEditReferenceNumbersModal = () => this.setState({ showEditReferenceNumbersModal: false });
        this.handleSaveReferenceNumbers = (referenceNumbers) => {
            ShipmentsActionCreators.updateReferenceNumbers(this.props.job, referenceNumbers);
            this.handleCloseEditReferenceNumbersModal();
        };
        this.openRequestChanges = () => {
            const { t } = this.props;
            return (React.createElement(CargomaticModal, { show: true, showCloseButton: true, onHide: this.onRequestModalHide, title: t('REQUEST_CHANGES'), location: "middle", dialogClassName: "modal-grid", body: React.createElement(DoRequestChanges, { match: { params: { id: this.props.job._id } } }), footer: null }));
        };
        this._canViewDeliveryOrderActions = () => {
            const isDrayage = this.props.job.shipment_type === 'drayage';
            // code of 60 is accepeted
            return isDrayage && getLatestStatus(this.props.job).status.code < 60;
        };
        this.renderDeliveryOrder = () => {
            if (this.props.isShipper)
                return null;
            const { t } = this.props;
            const extension = this.state.delivery_order_name
                ? this.state.delivery_order_name.split('.').pop().toUpperCase()
                : '';
            return (React.createElement("div", { className: "" },
                React.createElement("div", null,
                    React.createElement("h4", { className: "text-grey-darker" }, t('DELIVERY_ORDER')),
                    React.createElement("div", { className: "flex py-4 border-b border-solid border-grey-light" },
                        React.createElement("div", { className: "justify-center text-center" },
                            React.createElement("a", { className: "text-center no-underline", href: this.state.delivery_order_signed_link, target: "_blank", rel: "noopener noreferrer" },
                                React.createElement("div", null,
                                    React.createElement("span", { className: "text-4xl" },
                                        React.createElement("i", { className: `${getFileIconClass(extension)} pb-2 text-xl` })),
                                    React.createElement("div", null,
                                        React.createElement("span", null, t('DELIVERY_ORDER')))))),
                        this._canViewDeliveryOrderActions() && (React.createElement("div", { className: "px-8 py-4" },
                            React.createElement("button", { className: "button button-green", onClick: this.onAcceptDeliveryOrder }, t('ACCEPT')),
                            React.createElement("button", { className: "mx-1 button button-yellow", onClick: this.onRequestModalShow }, t('REQUEST_CHANGES')),
                            React.createElement("button", { className: "button button-red", onClick: () => {
                                    this.setState({ showConfirmDeclineModal: true });
                                } }, t('DECLINE'))))))));
        };
        this.state = {
            expanded: true,
            appointmentStop: null,
            showAddAppointmentModal: false,
            editingTrackingId: false,
            tracking_id: getTrackingId(props),
            showEditReferenceNumbersModal: false,
            expandReferenceNumbers: true,
            showRequestChangesModal: false,
            showConfirmDeclineModal: false,
            delivery_order_signed_link: null,
            yards: null,
            isCarrier: props.isCarrier,
        };
    }
    async retrieveSignedLink() {
        var _a, _b, _c, _d, _e;
        const lastDeliveryOrderResult = await getDocumentsV2([this.props.job._id], 'delivery_order', {
            order: {
                field: 'createdAt',
                direction: 'desc',
            },
            limit: 1,
        });
        if (this.findErrorsAndShowToast(lastDeliveryOrderResult, 'Get Documents')) {
            return;
        }
        if (((_c = (_b = (_a = lastDeliveryOrderResult === null || lastDeliveryOrderResult === void 0 ? void 0 : lastDeliveryOrderResult.data) === null || _a === void 0 ? void 0 : _a.getDocumentsV2) === null || _b === void 0 ? void 0 : _b.documents) === null || _c === void 0 ? void 0 : _c.length) > 0) {
            const signedUrlResult = await getSignedUrl(lastDeliveryOrderResult.data.getDocumentsV2.documents[0].key);
            if (this.findErrorsAndShowToast(signedUrlResult, 'Get SignedUrl')) {
                return;
            }
            const delivery_order_name = lastDeliveryOrderResult.data.getDocumentsV2.documents[0].name;
            if ((_e = (_d = signedUrlResult === null || signedUrlResult === void 0 ? void 0 : signedUrlResult.data) === null || _d === void 0 ? void 0 : _d.getSignedUrl) === null || _e === void 0 ? void 0 : _e.signedUrl) {
                const delivery_order_signed_link = signedUrlResult.data.getSignedUrl.signedUrl;
                this.setState({ delivery_order_signed_link, delivery_order_name });
            }
        }
    }
    async componentDidMount() {
        ShipmentStore.addDeliveryOrderStatusUpdateChangeListener(this.handleDeliveryOrderStatusUpdate);
        this.retrieveSignedLink();
        if (!isProd()) {
            const { market: { market_id: marketId }, } = this.props.job;
            const yardsResponse = await getYards('nameInternal', 'ascend', null, null, {
                id: null,
                marketId,
                nameInternal: null,
                status: null,
            });
            this.setState({ yards: yardsResponse.data.getYards.yards });
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.editingTrackingId) {
            return;
        }
        if (nextProps.job) {
            this.setState({
                tracking_id: getTrackingId(nextProps),
            });
        }
    }
    componentWillUnmount() {
        ShipmentStore.removeDeliveryOrderStatusUpdateChangeListener(this.handleDeliveryOrderStatusUpdate);
    }
    getLoads() {
        const { job: { loads }, } = this.props;
        return loads || [];
    }
    getBoxes() {
        return this.getLoads().filter((l) => l.type === 'boxes');
    }
    getPallets() {
        return this.getLoads().filter((l) => l.type === 'pallets');
    }
    getLoad(field) {
        const loads = this.getLoads();
        const boxes = loads.filter((l) => l.type === 'boxes')[0];
        const pallets = loads.filter((l) => l.type === 'pallets')[0];
        if (field === 'boxes' && !boxes) {
            return null;
        }
        if (field === 'pallets' && !pallets) {
            return null;
        }
        if (field === 'boxes') {
            return boxes;
        }
        return pallets;
    }
    getPalletLoads() {
        const { t } = this.props;
        const palletLoads = this.getPallets();
        const totalPalletSpaces = calculatePalletSpaces(palletLoads);
        return (React.createElement("div", { className: "load-field" },
            React.createElement("p", null, this.getFormattedLoadCount('pallets')),
            React.createElement("p", null, this.getFormattedLoadDimensions('pallets')),
            SessionStore.isAdmin() && (React.createElement("p", null,
                totalPalletSpaces,
                " ",
                t('PALLET_SPACES')))));
    }
    getBoxLoads() {
        const { t } = this.props;
        const boxLoads = this.getBoxes();
        const totalPalletSpaces = calculatePalletSpaces(boxLoads);
        return (React.createElement("div", { className: "load-field" },
            React.createElement("p", null, this.getFormattedLoadCount('boxes')),
            React.createElement("p", null, this.getFormattedLoadDimensions('boxes')),
            SessionStore.isAdmin() && (React.createElement("p", null,
                totalPalletSpaces,
                " ",
                t('PALLET_SPACES')))));
    }
    getFormattedLoadCount(field) {
        const { t } = this.props;
        const load = this.getLoad(field);
        const quantity = (load && load.quantity) || 0;
        let type = '';
        if (field === 'boxes') {
            type = quantity ? t('BOX', { count: 2 }) : t('BOX', { count: 1 });
        }
        else if (field === 'pallets') {
            type =
                quantity > 0 ? t('PALLET', { count: 2 }) : t('PALLET', { count: 2 });
        }
        return `${accounting.formatNumber(quantity)} ${titleize(type)}`;
    }
    getFormattedLoadDimensions(field) {
        const load = this.getLoad(field);
        if (!load) {
            return null;
        }
        const { width, height, length, dimensional_units } = load;
        if (width > 0 && height > 0 && length > 0) {
            return (React.createElement(LoadDimensionFormatter, { length: length, width: width, height: height, dimensional_units: dimensional_units }));
        }
        return null;
    }
    getFormattedDistance() {
        const { job: { distance }, localeData, } = this.props;
        if (!distance) {
            return null;
        }
        return (React.createElement(DistanceUnitFormatter, { fromUnit: "m", toUnit: localeData.distance_units, distance: distance }));
    }
    hasAccessorials() {
        const { job: { accessorials }, } = this.props;
        if (accessorials && Object.keys(accessorials).length > 0) {
            return true;
        }
        return false;
    }
    renderNotes() {
        const { job: { notes }, t, } = this.props;
        if (notes) {
            return (React.createElement("div", { className: "offer-misc-info" },
                React.createElement("h5", null, titleize(t('NOTE', { count: 2 }))),
                React.createElement("small", null, notes)));
        }
        return null;
    }
    renderHazMat() {
        if (!isHazMat(this.props.job)) {
            return null;
        }
        const { t } = this.props;
        return (React.createElement("section", { className: "my-4" },
            React.createElement(Alert, { type: "error", className: "upload-doc" },
                React.createElement("span", null, t('SHIPMENT_HAZARDOUS_MATERIALS'))),
            React.createElement("hr", null)));
    }
    renderAccessorials() {
        if (!this.hasAccessorials()) {
            return null;
        }
        const { job: { accessorials }, t, } = this.props;
        const mappedAcessorialImages = Object.keys(accessorials).map((key) => {
            const accessorial = accessorials[key];
            return React.createElement(OfferAccessorial, { key: key, accessorial: accessorial });
        });
        return (React.createElement("div", { className: "offer-misc-info" },
            React.createElement("h5", null, t('ACCESSORIAL', { count: 2 })),
            React.createElement("div", { className: "offer-accessorials" }, mappedAcessorialImages)));
    }
    renderLoad() {
        const { job: { loads, weight, weight_units }, t, } = this.props;
        const totalPalletSpaces = loads && loads.length ? calculatePalletSpaces(loads) : 0;
        return (React.createElement("div", { className: "load-field" },
            React.createElement("p", null, this.getFormattedDistance()),
            React.createElement("p", null,
                React.createElement(LoadUnitFormatter, { isTotalWeight: true, weight: weight, weight_units: weight_units })),
            totalPalletSpaces &&
                totalPalletSpaces > 0 &&
                SessionStore.isAdmin() ? (React.createElement("p", null, t('TOTAL_PALLET_SPACE_WITH_VALUE', {
                totalPalletSpace: totalPalletSpaces,
            }))) : null));
    }
    renderEquipment() {
        const { job: { stops }, t, } = this.props;
        const equipmentList = _.uniq(stops.reduce((equipments, stop) => {
            return equipments.concat(stop.equipments || []);
        }, []), false, (eq) => eq._id);
        if (!equipmentList.length) {
            return null;
        }
        return (React.createElement("div", null,
            React.createElement("div", { className: "flex flex-row px-2 pb-2 mb-3 text-sm font-bold border-b-2 border-solid text-grey-darker border-grey-light" },
                React.createElement("div", { className: "flex-1 min-w-150px" }, t('EQUIPMENT_ID')),
                React.createElement("div", { className: "flex-1 min-w-150px" }, titleize(t('TYPE'))),
                React.createElement("div", { className: "flex-1 min-w-100px" }, t('SIZE', { count: 1 }))),
            React.createElement("div", null, equipmentList.map((equipment) => {
                return (React.createElement("div", { className: "flex flex-row px-2 pb-2 text-sm", key: equipment._id },
                    React.createElement("span", { className: "flex-1 min-w-150px" }, `${equipment.equipment_id}`),
                    React.createElement("span", { className: "flex-1 min-w-150px" }, t(sluggify(equipment._type))),
                    React.createElement("span", { className: "flex-1 min-w-100px" }, equipment._equipmentSize)));
            }))));
    }
    renderRefNumbers() {
        const { t, job } = this.props;
        const isDrayage = isIntermodalShipmentType(job);
        const reference_numbers = this.props.job.reference_numbers;
        const renderedReferenceNumbers = reference_numbers.map((refNum) => {
            if (refNum.name === 'tracking_id') {
                return this.renderTrackingId(refNum);
            }
            return (React.createElement("div", { key: refNum.name },
                React.createElement("label", { className: "mb-2 form-label" }, t(sluggify(refNum.name), { count: 1 })),
                React.createElement("p", null, refNum.value)));
        });
        const showTrackingIdForm = reference_numbers.findIndex((n) => n.name === 'tracking_id') === -1;
        const referenceNumberForm = showTrackingIdForm
            ? this.renderTrackingId()
            : null;
        return (React.createElement("div", { className: "mb-6" },
            React.createElement("div", { className: "flex items-center mb-4" },
                React.createElement("h4", { className: "ml-0 mr-1 text-lg" },
                    this.props.t('REF'),
                    " #"),
                React.createElement(OverlayTrigger, { placement: "top", overlay: TOOLTIPS.references },
                    React.createElement(InformationCircleIcon, { className: "w-5 h-5" })),
                React.createElement(OverlayTrigger, { placement: "top", overlay: TOOLTIPS.editReferences, style: { display: 'inline-block' } },
                    React.createElement(PencilIcon, { className: "w-5 h-5 ml-3 cursor-pointer", onClick: this.handleEditReferenceNumbers }))),
            React.createElement("div", null,
                referenceNumberForm,
                renderedReferenceNumbers),
            React.createElement(EditReferenceNumbersModal, { isIntermodalShipmentType: isDrayage, reference_numbers: this.props.job.reference_numbers, shipper: this.props.job.shipper, show: this.state.showEditReferenceNumbersModal, onSave: this.handleSaveReferenceNumbers, onClose: this.handleCloseEditReferenceNumbersModal, page: "ShipmentDetails", isCarrier: this.props.isCarrier })));
    }
    renderTrackingId(refNum = {}) {
        const { t } = this.props;
        const { editingTrackingId } = this.state;
        const showReadonlyField = !editingTrackingId;
        const value = refNum.value || t('NONE');
        if (showReadonlyField) {
            return (React.createElement("div", { key: "tracking-id-readonly" },
                React.createElement("label", { className: "mb-2 form-label" }, t('TRACKING_ID')),
                React.createElement("p", { className: "flex" },
                    React.createElement("span", null, value),
                    SessionStore.isShipper() && (React.createElement("i", { style: { cursor: 'pointer', color: '#718DAC' }, className: "ml-2 fa fa-pencil", onClick: this.handleEditTrackingIdStart })))));
        }
        return (React.createElement("form", { className: "form-inline", key: "tracking-id-form" },
            React.createElement("div", { className: "mb-4" },
                React.createElement(FormControl, { type: "text", placeholder: t('ENTER_TRACKING_ID'), onChange: this.handleEditTrackingIdChange, value: this.state.tracking_id }),
                React.createElement(ButtonGroup, { style: { marginLeft: '0.5rem' } },
                    React.createElement(Button, { bsStyle: "primary", bsSize: "small", style: { marginRight: 0 }, disabled: !this.state.tracking_id, onClick: this.handleEditTrackingIdSave }, titleize(t('SAVE'))),
                    React.createElement(Button, { bsSize: "small", onClick: this.handleEditTrackingIdCancel }, t('CANCEL'))))));
    }
    renderDriver() {
        if (!this.props.activeDriver) {
            return null;
        }
        const { activeDriver: { phone, first_name, last_name }, } = this.props;
        const firstName = (first_name || '').trim();
        const lastName = (last_name || '').trim();
        const fullName = `${firstName} ${lastName}`.trim();
        return (React.createElement("div", { className: "mb-6" },
            React.createElement("h4", { className: "mb-4 ml-0 text-xl" }, titleize(this.props.t('DRIVER', { count: 1 }))),
            React.createElement("p", { className: "flex items-center" },
                React.createElement("i", { className: "mr-2 text-grey-darker fa fa-truck", "aria-hidden": "true" }),
                React.createElement("span", { className: "ml-2 text-sm" }, fullName)),
            React.createElement("p", { className: "flex" },
                React.createElement("i", { className: "text-grey-darker fa fa-phone", "aria-hidden": "true" }),
                React.createElement("span", { className: "ml-2 text-sm" }, phone))));
    }
    renderDates() {
        const { job: shipment } = this.props;
        if (!shipment || !shipment.order) {
            return null;
        }
        const hideDates = ['export', 'domestic'].includes(shipment.order.order_type);
        if (hideDates) {
            return null;
        }
        const { estimated_arrival, arrival_date, discharge_date, last_free_date, rail_lfd_at_facility_estimated, rail_earliest_return, rail_cut_date, } = shipment;
        const { t } = this.props;
        return (React.createElement("div", { className: "" },
            React.createElement("h4", { className: "text-xl" }, t('DATES')),
            React.createElement("div", { className: "flex flex-wrap -mx-4" },
                React.createElement("div", { className: "w-full px-4 md:w-1/2" },
                    React.createElement(ShipmentDetailDateItem, { title: t('ETA'), value: estimated_arrival, editable: true, heapClassName: "shipment-jobDetailCard-editETA heap", onSave: this.handleSaveShipmentDate('estimated_arrival') }),
                    React.createElement(ShipmentDetailDateItem, { title: t('ARRIVAL'), value: arrival_date, editable: true, heapClassName: "shipment-jobDetailCard-editArrivalDate heap", onSave: this.handleSaveShipmentDate('arrival_date') })),
                React.createElement("div", { className: "w-full px-4 md:w-1/2" },
                    React.createElement(ShipmentDetailDateItem, { title: t('DISCHARGE'), value: discharge_date, editable: true, heapClassName: "shipment-jobDetailCard-editDischargeDate heap", onSave: this.handleSaveShipmentDate('discharge_date') }),
                    React.createElement(ShipmentDetailDateItem, { title: t('LAST_FREE'), value: last_free_date, editable: true, heapClassName: "shipment-jobDetailCard-editLastFreeDate heap", onSave: this.handleSaveShipmentDate('last_free_date') }),
                    rail_lfd_at_facility_estimated && (React.createElement(ShipmentDetailDateItem, { title: t('LFD_AT_RAIL_FACILITY_ESTIMATED'), key: "LFD At Rail Facility Estimated", heapClassName: "shipment-jobDetailCard-LFDAtRailFacilityEstimatedDate heap", value: rail_lfd_at_facility_estimated })),
                    rail_earliest_return && (React.createElement(ShipmentDetailDateItem, { title: t('RAIL_EARLIEST_RETURN_DATE'), key: "Rail Earliest Return Date", heapClassName: "shipment-jobDetailCard-RailEarliestReturnDate heap", value: rail_earliest_return })),
                    rail_cut_date && (React.createElement(ShipmentDetailDateItem, { title: t('RAIL_CUT_DATE'), key: "Rail Cut Date", heapClassName: "shipment-jobDetailCard-RailEarliestReturnDate heap", value: rail_cut_date }))))));
    }
    renderFirstRow() {
        var _a, _b, _c, _d;
        const { job: { order }, } = this.props;
        const { t } = this.props;
        const shipperHideColumnProperties = (_d = (_c = (_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.job) === null || _b === void 0 ? void 0 : _b.shipper) === null || _c === void 0 ? void 0 : _c.hide_column_properties) !== null && _d !== void 0 ? _d : [];
        const showDriver = !this.props.isShipper || !shipperHideColumnProperties.includes('driver');
        return (React.createElement("div", { className: "flex flex-wrap -mx-4" },
            React.createElement("div", { className: "w-full px-4 py-4 md:w-1/3" },
                this.renderRefNumbers(),
                order && (React.createElement("div", { className: "text-sm" },
                    React.createElement("label", { className: "mb-2 form-label" }, t('SSL_RR')),
                    React.createElement("p", null, order.steamship_or_railroad)))),
            React.createElement("div", { className: "w-full px-4 py-4 md:w-2/3" },
                showDriver ? this.renderDriver() : null,
                this.renderDates())));
    }
    renderAddAppointmentModal() {
        if (!this.state.showAddAppointmentModal) {
            return null;
        }
        const { appointmentStop } = this.state;
        return (React.createElement(AddAppointmentModal, { stop: appointmentStop, shipment: this.props.job, show: this.state.showAddAppointmentModal, onSave: this.handleWindowSave, onHide: this.handleCancelWindowEdit }));
    }
    renderStops() {
        const { job, t } = this.props;
        const stops = _.sortBy(job.stops || [], (s) => s.sequence);
        const miles = this.getFormattedDistance();
        const appointmentEditable = canEditAppointmentWindow(job);
        const isDrayage = isIntermodalShipmentType(job);
        const yardName = (yardId) => {
            const { yards } = this.state;
            if (yards && yards.length) {
                return yards
                    .filter((yard) => yard.id === yardId)
                    .map((item) => {
                    return SessionStore.isAdmin()
                        ? item.nameInternal
                        : item.nameExternal;
                });
            }
            return null;
        };
        return (React.createElement("div", { className: "-mx" },
            React.createElement("div", { className: "flex mb-4" },
                React.createElement("h4", { className: "pr-1 ml-0 text-xl" }, t('ROUTE')),
                React.createElement("h5", { className: "my-auto" },
                    ' ',
                    "- ",
                    stops.length,
                    " ",
                    t('STOP', { count: 2 }),
                    " (",
                    miles,
                    ")")),
            stops.map((stop) => (React.createElement(Stop, { yardName: yardName(stop.yardId), stop: stop, onEditAppointmentWindow: this.handleEditAppointmentWindow, shipment_type: job.shipment_type, appointmentEditable: isDrayage && appointmentEditable })))));
    }
    renderSteps() {
        const { job } = this.props;
        if (featureEnabled(CONFIGURED_FEATURES.SSR) &&
            isIntermodalShipmentType(job) &&
            !SessionStore.isShipper()) {
            return React.createElement(NextSteps, { shipment: job });
        }
        return null;
    }
    render() {
        const hasPalletLoads = this.getPallets().length > 0;
        const hasBoxLoads = this.getBoxes().length > 0;
        const loadHeaderStyle = {
            marginTop: '0.4em',
            display: 'flex',
            flexDirection: 'row',
        };
        const { job, t } = this.props;
        return (React.createElement("div", { className: "offer-panel" },
            React.createElement("div", { className: "panel-body offer-list-item" },
                React.createElement(Disclosure, null,
                    React.createElement(React.Fragment, null,
                        this.renderHazMat(),
                        this.renderSteps(),
                        !isProd() && this.renderDeliveryOrder(),
                        this.renderFirstRow(),
                        !isProd()
                            ? this.state.yards && this.renderStops() // avoid text replacement
                            : this.renderStops(),
                        React.createElement("div", { style: loadHeaderStyle, className: "justify-between" },
                            React.createElement("h4", { className: "mt-0 mb-4 ml-0 text-xl" }, t('LOAD_DETAILS')),
                            React.createElement(Disclosure.Button, { className: "offer-view-more" }, ({ open }) => (React.createElement(React.Fragment, null,
                                !open && React.createElement(ChevronRightIcon, { className: "w-5 h-5" }),
                                open && React.createElement(ChevronUpIcon, { className: "w-5 h-5" }))))),
                        React.createElement(Disclosure.Panel, null,
                            React.createElement("div", { className: "offer-details" },
                                React.createElement("div", { className: "offer-info" },
                                    this.renderLoad(),
                                    hasPalletLoads && this.getPalletLoads(),
                                    hasBoxLoads && this.getBoxLoads()),
                                React.createElement("div", { className: "offer-info" }, this.renderEquipment()),
                                this.renderAccessorials(),
                                this.renderNotes()))))),
            React.createElement(ConfirmModal, { show: this.state.showConfirmDeclineModal, title: t('CONFIRM_ACTION'), message: t('DECLINE_CONFIRMATION_COMMENT'), onHide: () => this.setState({ showConfirmDeclineModal: false }), onConfirm: this.onDeclineDeliveryOrder, hideButtonText: t('CANCEL'), affirmative: t('OK') }),
            this.renderAddAppointmentModal(),
            this.state.showRequestChangesModal && this.openRequestChanges()));
    }
}
JobDetailCard.propTypes = {
    isShipper: PropTypes.bool,
    isCarrier: PropTypes.bool,
    job: PropTypes.shape({
        _id: PropTypes.string.isRequired,
        shipment_id: PropTypes.string.isRequired,
        shipment_type: PropTypes.string.isRequired,
        exposed_at: PropTypes.string.isRequired,
        pickup_after: PropTypes.string.isRequired,
        pickup_by: PropTypes.string.isRequired,
        reference_numbers: PropTypes.array,
        total_payable_rate: PropTypes.number.isRequired,
        deliver_after: PropTypes.string.isRequired,
        deliver_by: PropTypes.string.isRequired,
        pallets: PropTypes.arrayOf(PropTypes.shape({
            width: PropTypes.number.isRequired,
            height: PropTypes.number.isRequired,
            length: PropTypes.number.isRequired,
        })).isRequired,
        weight: PropTypes.number.isRequired,
        distance_in_miles: PropTypes.number.isRequired,
        origin: PropTypes.arrayOf(PropTypes.shape({
            city: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
        })),
        destination: PropTypes.arrayOf(PropTypes.shape({
            city: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
        })),
        stops: PropTypes.arrayOf(PropTypes.shape({
            location: PropTypes.arrayOf(PropTypes.shape({
                city: PropTypes.string.isRequired,
                name: PropTypes.string,
                address: PropTypes.string,
            })),
            loads: PropTypes.arrayOf(PropTypes.shape({
                weight: PropTypes.number,
                width: PropTypes.number,
                lenght: PropTypes.number,
                height: PropTypes.number,
            })),
        })),
    }).isRequired,
    activeDriver: PropTypes.shape({
        fullName: PropTypes.string,
        phone: PropTypes.string,
    }),
};
JobDetailCard.defaultProps = {
    activeDriver: null,
};
export default withTranslation()(withLocaleContext(JobDetailCard));
